import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TwoBtnModal } from "components/common/modal";
import { delFoldingScreen } from "service/api/digital";
import routerConstant from "service/constant/routerConstant";
import type { IFoldingScreen } from "service/interface/digital";
import { KeyedMutator } from "swr";
import responseCodeConstant from "service/constant/responseCodeConstant";

interface Props {
  data: IFoldingScreen[];
  mutate: KeyedMutator<any>;
}

export function FoldingScreenListTable({ data, mutate }: Props) {
  const navigate = useNavigate();
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [selectDeleteId, setSelectDeleteId] = useState<number>(0);

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.FOLDINGSCREEN.index}/${id}`);
  };

  const handleDeleteBtn = (id: number) => {
    setSelectDeleteId(id);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteModalBtn = async () => {
    const delRes = await delFoldingScreen(selectDeleteId + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      mutate();
    }
  };

  return (
    <>
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="해당 게시글을 삭제하시겠습니까?"
        subTitle=""
        btnLabel="삭제하기"
        btnClick={handleDeleteModalBtn}
      />
      <div className="w-ful">
        <table className="w-full divide-y divide-[#d1dff3]">
          <thead>
            <tr>
              <th
                scope="col"
                className="min-w-[71px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                ID
              </th>
              <th
                scope="col"
                className="min-w-[238px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                제목
              </th>
              <th
                scope="col"
                className="min-w-[250px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                병풍 이미지
              </th>
              <th
                scope="col"
                className="min-w-[250px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                설명 이미지
              </th>
              <th
                scope="col"
                className="min-w-[110px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                생성일
              </th>
              <th
                scope="col"
                className="min-w-[104px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                편집
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map((folding) => (
              <tr
                key={folding.id}
                className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
                onClick={() => handleTableClick(folding.id)}
              >
                <td className="h-[106px] whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                  {folding.id}
                </td>
                <td className="h-[106px] whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  {folding.title}
                </td>
                <td className="h-[106px]whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  <img
                    src={folding.imgSrc}
                    alt="folding screen img"
                    className="max-h-[74px] max-w-[227px]"
                  />
                </td>
                <td className="h-[106px] whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  <img
                    src={folding.explainImgSrc}
                    alt="folding screen img"
                    className="max-h-[74px] max-w-[227px]"
                  />
                </td>
                <td className="h-[106px] whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {moment(folding.createdAt).format("YYYY-MM-DD")}
                </td>
                <td
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteBtn(folding.id);
                  }}
                  className="h-[106px] cursor-pointer whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5"
                >
                  삭제
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
